<template>
  <div
    ref="nz_toggle_wrap"
    class="nz-toggle-wrap"
    :class="getStyle()"
    :disabled="disabled"
    :style="wrapStyle()"
  >
    <div class="nz-toggle">
      <div ref="nz_toggle_handle" class="nz-toggle-handle" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NzToggle',
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      },
    },
    disabled: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      elToggle: null,
      state: this.value,
      width: 50,
      height: 25,
      pressed: {
        y: 0,
        x: 0,
      },
      current: 0,
      change: 0,
      movement: 0,
      now: 0,
      styleMap: {
        false: 0,
        true: 100,
      },
    };
  },
  mounted: function () {
    this.elToggle = this.$refs.nz_toggle_handle;

    this.$nextTick(function () {
      this.addEventListeners(this.$refs.nz_toggle_wrap, 'click', this.onClick);

      this.addEventListeners(
        this.$refs.nz_toggle_wrap,
        'mousedown touchstart',
        this.onToggleTouch
      );
    });
  },
  methods: {
    onClick() {
      if (this.disabled) return;
      if (this.movement < 1) {
        this.toggle();
        return;
      }
    },
    toggle(state) {
      if (state != null) {
        this.state = state;
      } else {
        this.state = !this.state;
      }

      this.onToggle();
    },
    onToggleTouch(e) {
      if (this.disabled) return;
      e = e ? e : window.event;

      this.pressed = {
        x: e.pageX || e.touches[0].pageX,
        y: e.pageY || e.touches[0].pageY,
      };

      this.movement = 0;

      this.elToggle.style.transition = '0s';

      this.addEventListeners(window, 'mousemove touchmove', this.onToggleMove);
      this.addEventListeners(window, 'mouseup touchend', this.onToggleRelease);

      e.preventDefault();
      e.returnValue = false;
      return false;
    },
    onToggleMove(e) {
      e = e ? e : window.event;

      var h = (e.pageX || e?.touches[0]?.pageX) - this.pressed.x,
        cWidth = this.$el.childNodes[0].offsetWidth,
        wp = (h / (cWidth / 2)) * 100;

      this.current = parseFloat(this.styleMap[this.value.toString()]);
      this.change = Math.max(Math.min(parseFloat(wp + this.current), 100), 0);
      this.now = this.current + (this.change - this.current) / 2;
      this.movement = Math.max(this.movement, Math.abs(h));

      this.elToggle.style.left = `${this.now}%`;

      e.preventDefault();
      e.returnValue = false;
      return false;
    },
    async onToggleRelease(e) {
      e = e ? e : window.event;

      this.pressed = null;

      this.$nextTick(() => {
        if (this.movement < 1 && e.type == 'mouseup') {
          return;
        }

        if (this.movement < 1 && e.type == 'touchend') {
          this.toggle();
          return;
        }

        if (this.change < 50) {
          this.toggle(false);
          return;
        }

        this.toggle(true);
        return;
      });

      this.elToggle.style = {
        left: '',
        transition: '',
      };

      this.removeEventListeners(
        window,
        'mousemove touchmove',
        this.onToggleMove
      );

      this.removeEventListeners(
        window,
        'mouseup touchend',
        this.onToggleRelease
      );

      e.preventDefault();
      e.returnValue = false;
      return false;
    },
    wrapStyle() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
      };
    },
    getStyle() {
      return ['horizontal', this.value.toString()];
    },
    addEventListeners(el, s, fn) {
      var evts = s.split(' ');
      for (var i = 0, iLen = evts.length; i < iLen; i++) {
        if (el && el.addEventListener) {
          el.addEventListener(evts[i], fn, false);
        }
      }
    },
    removeEventListeners(el, s, fn) {
      var evts = s.split(' ');
      for (var i = 0, iLen = evts.length; i < iLen; i++) {
        el.removeEventListener(evts[i], fn, false);
      }
    },
    onToggle() {
      this.$emit('onToggle', this.state);
      this.$emit('input', this.state);
    },
  },
};
</script>